import React, { useState } from "react";
import { IconButton, MenuItem, Box, Typography, Paper, ClickAwayListener, MenuList } from "@mui/material";
import { changeLanguage, getCurrentLanguage } from "@/i18n";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "en", flag: "🇺🇸", label: "English" },
  { code: "id", flag: "🇮🇩", label: "Bahasa Indonesia" },
] as const;

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language || getCurrentLanguage();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (code: string) => {
    changeLanguage(code);
    handleClose();
  };

  const current = LANGUAGES.find((l) => l.code === currentLang) || LANGUAGES[1];

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <IconButton color="inherit" onClick={handleOpen} size="small">
        <span style={{ fontSize: 20 }}>{current.flag}</span>
      </IconButton>

      {Boolean(anchorEl) && (
        <ClickAwayListener onClickAway={handleClose}>
          <Paper
            elevation={3}
            sx={{
              position: 'absolute',
              top: '100%',
              right: 0,
              zIndex: 1500,
              mt: 1,
              minWidth: 180,
              overflow: 'hidden'
            }}
          >
            <MenuList disablePadding>
              {LANGUAGES.map((lang) => (
                <MenuItem
                  key={lang.code}
                  onClick={() => handleSelect(lang.code)}
                  selected={lang.code === currentLang}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <span>{lang.flag}</span>
                    <Typography>{lang.label}</Typography>
                  </Box>
                </MenuItem>
              ))}
            </MenuList>
          </Paper>
        </ClickAwayListener>
      )}
    </Box>
  );
};

export default LanguageSwitcher;
